import loadCachedFonts from '@/store/Common/GoogleFonts/loadCachedFonts.js';
import axios from 'axios';

export default {
    namespaced: true,

    state: {
        paletteId: undefined,
        palette: [],
        palettes: [],
        paletteComplete: false,
        color1: undefined,
        color2: undefined,
        color3: undefined,
        fontId: [],
        font: [],
        fonts: [],
        font1: undefined,
        font1Size: undefined,
        font2: undefined,
        font2Size: undefined,
        fontSwatchStyle: undefined,
        pairingComplete: false,
        pairingId: undefined,
        pairings: []
    },

    mutations: {
        setPalettes(state, value) {
            state.palettes = value;
        },

        setPaletteId(state, value) {
            state.paletteId = value;
        },

        setPaletteComplete(state, value) {
            state.paletteComplete = value;
        },

        setPairingComplete(state, value) {
            state.pairingComplete = value;
        },

        setColor1(state, value) {
            state.color1 = value;
        },

        setColor2(state, value) {
            state.color2 = value;
        },

        setColor3(state, value) {
            state.color3 = value;
        },

        setPairings(state, value) {
            state.pairings = value;
        },

        setPairingId(state, value) {
            state.pairingId = value;
        },

        setFont1(state, value) {
            state.font1 = value;
        },

        setFont1Size(state, value) {
            state.font1Size = value;
        },

        setFont2(state, value) {
            state.font2 = value;
        },

        setFont2Size(state, value) {
            state.font2Size = value;
        },

        setFonts(state, value) {
            state.fonts = value;
        },

        setFontSwatchStyle(state, value) {
            state.fontSwatchStyle[value.key] = value.style;
        },
    },

    actions: {
        getAllPalettes({commit}) {
            return new Promise((resolve, reject) => {
                axios.get('/api/palette/show')
                    .then(response => {
                        commit('setPalettes', response.data.data.palettes);
                        resolve();
                    })
                    .catch(() => {
                        reject();
                    });
            });
        },

        getAllPairings({commit}) {
            return new Promise((resolve, reject) => {
                axios.get('/api/font-pairing/show')
                    .then(response => {
                        commit('setPairings', response.data.data.pairings);
                        resolve();
                    })
                    .catch(() => {
                        reject();
                    });
            });
        },

        loadFontSelectors({commit}) {
            loadCachedFonts()
                .then((response) => {
                    commit('setFonts', response);
                });
        }
    },
};
